import api, { UPLOAD_API } from "../axiosInstance";

const formService = {
  submitQc: (data) => api.post(`vehicle`, data),
  updateVehicleStatus: (data) => api.put(`vehicle/status`, data),
  submitPayment: (data) => api.post(`payment`, data),
  getFinanceData: (leadId) => api.get(`payment/${leadId}`),
  deletePayment: (paymentId) => api.delete(`/payment/${paymentId}`),
  fetchPPSRReport: (appointmentId, page, size) =>
    UPLOAD_API.get(`api/v1/vehicle/ppsr/search?appointmentId=${appointmentId}&size=${size}&page=${page}&source=DMS`),
  generatePPSRReport: (appointmentId) =>
    UPLOAD_API.post(`api/v1/vehicle/ppsr?refresh=true`, { appointmentId, source: "DMS" }),
  checkPPSRUpdateStatus: (appointmentId) =>
    UPLOAD_API.post(`api/v1/vehicle/ppsr/updates`, { appointmentId, source: "DMS" }),
  fetchDownloadLink: (path) => UPLOAD_API.get(`/api/v1/file/preSigned?filePath=${path}`)
};

export default formService;
